























import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Slot from '../../models/Slot';

import './SlotList.scss';

@Component
export default class SlotList extends Vue {
  @Prop({ type: String, required: false }) slotListId!: string;
  @Prop({ type: String, required: false }) labelForList!: string;
  @Prop({ type: String, required: false }) labelForListElement!: string;
  @Prop({ type: Boolean, required: false, default: false }) isRemoveIcon!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) isCreateMode!: boolean;
  @Prop({ type: Array, required: true }) slots!: Slot[];

  private parseDate(date: number): string {
    if (date.toString().length > 5) {
      return moment.unix(date).format('HH:mm');
    }

    return date.toString();
  }
}
